var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    className: "opacity-0 my-svg pointer-events-auto animated",
    "data-v-6f4b6142": "",
    style: {
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#1572B6",
    d: "M18.814 114.123 8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33A9DC",
    d: "m64.001 117.062 36.559-10.136 8.601-96.354h-45.16v106.49z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "m64.083 87.349-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m81.127 64.675-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z",
    style: {
      strokeDashoffset: 0,
      strokeDasharray: "none",
      strokeWidth: 2,
      stroke: "white",
      fillOpacity: 0
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.fd89a97fdb47436e1a606ba715b979a6.svg";
export { ForwardRef as ReactComponent };